import { Maximize, Minimize, ArrowLeft } from 'lucide-react';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface IframeViewerProps {
  url: string | undefined;
}

export default function IframeViewer({ url }: IframeViewerProps) {
  if (!url) return null;

  const [isFullScreenMode, setFullScreenMode] = useState(false)
  const modalRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const toggleScreenSize = async () => {
    const element = modalRef.current;

    if (!element) return;

    if (!isFullScreenMode) {
      // Enter fullscreen with browser compatibility
      try {
        if (element.requestFullscreen) {
          await element.requestFullscreen();
        } else if ((element as any).webkitRequestFullscreen) {
          await (element as any).webkitRequestFullscreen();
        } else if ((element as any).mozRequestFullScreen) {
          await (element as any).mozRequestFullScreen();
        } else if ((element as any).msRequestFullscreen) {
          await (element as any).msRequestFullscreen();
        }
        setFullScreenMode(true);
      } catch (err) {
        console.error('Error entering fullscreen:', err);
      }
    } else {
      // Exit fullscreen with browser compatibility
      try {
        if (document.exitFullscreen) {
          await document.exitFullscreen();
        } else if ((document as any).webkitExitFullscreen) {
          await (document as any).webkitExitFullscreen();
        } else if ((document as any).mozCancelFullScreen) {
          await (document as any).mozCancelFullScreen();
        } else if ((document as any).msExitFullscreen) {
          await (document as any).msExitFullscreen();
        }
        setFullScreenMode(false);
      } catch (err) {
        console.error('Error exiting fullscreen:', err);
      }
    }
  };

  return (
    <div ref={modalRef} className="iframe-wrapper">
      <iframe
        src={url}
        className="iframe-box"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      />
      <div className='iframe-footer'>
        <ArrowLeft onClick={() => { navigate(-1) }} size={36} color='white' cursor='pointer' />
        {isFullScreenMode ? (<Minimize onClick={toggleScreenSize} size={36} color='white' cursor='pointer' />) :
          (<Maximize onClick={toggleScreenSize} size={36} color='white' cursor='pointer' />)
        }
      </div>

      <style>{`
        .iframe-wrapper {
          width: 80%;
          height: 80vh;
          background: #0a0a0aff;
          border: 1px solid rgba(255,255,255,0.1);
          overflow: hidden;
          display: flex;
          margin: auto;
          flex-direction: column;
          justify-content: center;
        }

        .iframe-header {
          padding: 10px 14px;
          background: #15111aff;
          color: #fff;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
        }

        .iframe-header button {
          background: rgba(255, 255, 255, 0.15);
          border: none;
          color: white;
          border-radius: 6px;
          padding: 4px 8px;
          cursor: pointer;
        }

        .iframe-box {
          flex: 1;
          width: 100%;
          border: none;
        }

        .iframe-footer {
          display: flex;
          justify-content: space-between;
          padding: 6px 10px 6px 10px;}
      `}</style>
    </div>
  );
}
